import { createContext, useContext } from "react";
export const AuthApi = createContext();
export const useAuth = () => {
    return useContext(AuthApi);
}